import { render } from "./Staffs.vue?vue&type=template&id=758f04d9&scoped=true"
import script from "./Staffs.vue?vue&type=script&lang=js"
export * from "./Staffs.vue?vue&type=script&lang=js"

import "./Staffs.vue?vue&type=style&index=0&id=758f04d9&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758f04d9"]])

export default __exports__